import { FlowTypes } from '@interfaces/models';

export const openChoiceEnabledFlowTypes = [FlowTypes.MINOR];
